import React, { useState } from 'react';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import moment from 'moment';

export default function Island({
  children = [],
  legend = {},
  desc = null,
  mT = false,
  headerText = '',
  lastUpdate = null,
  t = (s) => s,
}) {
  const [toggled, setToggled] = useState(true);

  const toggle = () => setToggled((prev) => !prev);

  return (
    <div className={mT ? `island island-mt` : 'island'}>
      <div className="cont-header">
        <div className="top">
          <h1>{headerText}</h1>
          <div className="legend">
            {!toggled && Object.entries(legend).map(([k, v]) => (
              <div
                className="legend-item"
                key={`legend-item-${headerText}-${k}`}
              >
                <div className="cont">
                  <div className="rounded" style={{ background: v.color }} />
                </div>
                <div className="cont">
                  <p>
                    {v.value}
                    {' '}
                    {v.label}
                  </p>
                </div>
              </div>
            ))}
            {typeof lastUpdate === 'string' && (
              <div className="cont">
                <label className="last-update">
                  {t('Last Updated')}:
                  {' '}
                  <strong>
                    {moment(lastUpdate).format('DD MMM YYYY')}
                  </strong>
                </label>
              </div>
            )}
            <div
              onClick={toggle}
              className={formatClassname(["toggle", !toggled && 'unactive'])}
            >
              {toggled ? <DownOutlined /> : <RightOutlined />}
            </div>
          </div>
        </div>
        {(typeof desc === 'string' && toggled) && <label>{desc}</label>}
      </div>
      <div
        className={formatClassname(["cont-body", !toggled && 'unactive'])}
      >
        {children}
      </div>
    </div>
  );
}
